// src/components/Home.js
import React from "react";
import "./Home.css";

function Home() {
  return (
    <section id="home" className="home-section">
      <div className="intro">
        <h2>Hello, I'm <span>Vivek Chary</span></h2>
        <h3>Full Stack Developer & Machine Learning Enthusiast</h3>
        <p>
          I’m passionate about building creative, efficient, and user-friendly
          web applications. I enjoy turning complex problems into simple,
          beautiful solutions using modern technologies.
        </p>
      </div>
      <div className="image">
        <img src="/images/photo.jpeg" alt="Vivek Chary" />
      </div>
    </section>
  );
}

export default Home;

